// types
import { Wallet } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Grid, Paper, Typography } from '@mui/material';

// ui
import { BlockchainHash } from '../../ui/BlockchainHash/BlockchainHash';

export interface CardWalletProps {
	wallet: Wallet;
}

export const CardWallet = ({ wallet }: CardWalletProps) => {
	// hooks
	const { t } = useTranslation();

	return (
		<Paper sx={{ height: '100%', padding: 2 }}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h3">{t('wallet')}</Typography>
				</Grid>
				<Grid item xs={12}>
					{wallet ? <BlockchainHash hash={wallet.address} isFullWidth={true} /> : t('na')}
				</Grid>
			</Grid>
		</Paper>
	);
};
